import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Flatten } from 'shared/helpers';
import { renderables } from 'shared/constants';

import Styles from './ComparativoFontes.module.scss';
import { faCode } from '@fortawesome/free-solid-svg-icons';

import { Creators as reduxProdutos } from 'store/ducks/produtos';
import { Creators as reduxEtapas } from 'store/ducks/etapas';

import Header from 'components/Header/Header';
import Table from './Table/Table';
import Subtable from 'components/Subtable/Subtable';
import PrintButton from 'components/PrintButton/PrintButton';

export default function ComparativoFontes({ match }) {
  const { ComparativoFontes } = Styles;
  const { id } = match.params;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(reduxEtapas.getEtapas(id));
    dispatch(reduxProdutos.getProdutos());
  }, [id, dispatch]);

  const RProdutos = useSelector((state) => state.produtos.data);
  const Etapas = useSelector((state) => state.etapas.data);
  const pem = useSelector((state) => state.etapas.pem);

  const Produtos = RProdutos.map((x) => ({
    N: Number(x.NH2) + Number(x.NH4) + Number(x.NO3),
    ...x,
  }));

  const etapas = Etapas.map((etapa) => ({
    ...etapa,
    produtos: etapa.produtos.map((produto) => ({
      ...produto,
      ...Produtos.find((x) => x.id === produto.id),
    })),
  }));

  const RelevantProdutos = Flatten(
    Etapas.map((etapa) =>
      etapa.produtos.map((produto) => ({
        ...Produtos.find((x) => x.id === produto.id),
        ...produto,
      })),
    ),
  );

  return pem !== id ? null : (
    <div className={ComparativoFontes}>
      <Header
        icon={faCode}
        title={
          'COMPARATIVO DA DISTRIBUIÇÃO E PROPORÇÃO DAS FONTES DE NITROGÊNIO'
        }
      >
        <PrintButton />
      </Header>
      <main>
        <Table
          id='table_comparativos'
          renderables={renderables}
          etapas={etapas}
          produtos={Produtos}
          tableKey={'comparativoFontes'}
        />
        <p>* micro elementos que podem ser quelatados</p>
        <Subtable produtos={RelevantProdutos} />
      </main>
    </div>
  );
}

ComparativoFontes.propTypes = {
  match: PropTypes.any.isRequired,
};
